import request from '@/api/request'

export const publicKey = params => request('passwordPublickKeyHttp')//获取公钥
export const userInfoSimple = params => request('userInfoHttp')//获取用户信息
export const userInfoDetail = params => request('userInfoDetailHttp',{loading: false})//获取用户信息
export const queryMenuList = params => request('menuListHttp')//获取顶部菜单栏
export const querySimCode = params => request('querySimCodeHttp', {params, returnAll: true})//获取收哦验证码
export const changeLanguage = params => request('changeLanguageTypeHttp', {params})//获取顶部菜单栏
export const closeFirstOpen = params => request('closeFirstOpenHttp', {loading:false})//获取顶部菜单栏